//import './loading.css';

const LoadingAnimation = () => {
    return (
        <div className="d-flex justify-content-center p-4">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}

export default LoadingAnimation;